import NumericCell from "./NumericCell";
import SelectionCell from "./SelectionCell";
import TextCell from "./CharCell";
import IntegerCell from "./IntegerCell";
import FloatCell from "./FloatCell";
import BooleanCell from "./BooleanCell";
import DropdownCell from "./DropdownCell";
import DatetimeCell from "./DatetimeCell";
import CharCell from "./CharCell";
import DateCell from "./DateCell";
import ButtonTable from "componentsv2/button/ButtonTable";
import CircleCell from "./CircleCell";
import Badge from "componentsv2/widgets/Badge";
import ButtonCustomModal from "componentsv2/table/ButtonCustomModal";
import CallAction from "components/MeTable/CallAction";
import QrCell from "./QrCell";
import ImageCell from "./ImageCell";
import CustomComponentCell from "componentsv2/experimental/CustomComponentCell";
// import ButtonCustomModal from "components/MeTable/ButtonCustomModal";
// import ButtonCustomModal from "./ButtonCustomModal";
// import IconSource from "components/Icons/IconSource";
// In future

const poolCell = {
  char: CharCell,
  numeric: NumericCell,
  selection: SelectionCell,
  text: TextCell,
  date: DateCell,
  date_2: DateCell,
  datetime: DatetimeCell,
  integer: IntegerCell,
  float: FloatCell,
  boolean: BooleanCell,
  many2one: DropdownCell,
  button: ButtonTable,
  image: ImageCell,
  badge: Badge,
  circle: CircleCell,
  qr: QrCell,
  call_action: CallAction,
  // experimental
  custom_component: CustomComponentCell,
  button_custom_modal: ButtonCustomModal,
};

export default poolCell;
